function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#Warning_svg__clip0)"
}, React.createElement("path", {
  d: "M24 37.5a.75.75 0 100 1.5.75.75 0 000-1.5z"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.75 38.25a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zM24 39a.75.75 0 100-1.5.75.75 0 000 1.5zm0-24a1.5 1.5 0 011.5 1.5v15a1.5 1.5 0 11-3 0v-15A1.5 1.5 0 0124 15z"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.747.524a5.112 5.112 0 016.841 2.334l18.945 38.595A4.543 4.543 0 0143.453 48H4.545a4.541 4.541 0 01-4.078-6.546L19.411 2.86A5.105 5.105 0 0121.747.524zm4.148 3.657a2.112 2.112 0 00-3.79 0L3.159 42.776A1.542 1.542 0 004.544 45h38.912a1.544 1.544 0 001.387-2.22L25.895 4.18z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "Warning_svg__clip0"
}, React.createElement("path", {
  d: "M0 0h48v48H0V0z"
})));

function SvgWarning(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
}

export default SvgWarning;